import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api/gameApi'
import {
  getScoreSnapShotAddressSuccess,
  getScoreSnapShotAddressFailed,
  GET_LIST_SNAPSHOT_ADDRESS_START,
} from '~/views/app/redux/actions/user'

/**
 * get score snapshot by wallet api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */

const getScoreSnapshotAddressApi = (props) => {
  var uri = `/api/game/score-snapshot/get2`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */

function* doGetScoreSnapshotAddress(action) {
  try {
    const response = yield call(getScoreSnapshotAddressApi, action?.payload)
    yield put(getScoreSnapShotAddressSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getScoreSnapShotAddressFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}
/**
 * [Watcher]
 * Watch get score snapshot by wallet
 */
export default function* watchGetScoreSnapshotAddress() {
  yield takeLatest(GET_LIST_SNAPSHOT_ADDRESS_START, doGetScoreSnapshotAddress)
}
